import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Import translations
import en from "./locales/en.json";
import fr from "./locales/fr.json";
import uk from "./locales/uk.json";
import de from "./locales/de.json";
import kz from "./locales/kz.json";
import by from "./locales/by.json";

export const SUPPORTED_LNGS = ['en', 'fr', 'uk', 'de', 'kz', 'by'] as const
export type SupportedLng = (typeof SUPPORTED_LNGS)[number]

// Initialize i18n
void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      fr: { translation: fr },
      uk: { translation: uk },
      de: { translation: de },
      kz: { translation: kz },
      by: { translation: by },
    },
    fallbackLng: "en",
    supportedLngs: [...SUPPORTED_LNGS],
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
    },
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;

